module.exports = __webpack_public_path__ + "static/media/beautiful-bean-co-yellow.3617db4a.svg";